import React, { useState, useEffect, useCallback } from 'react';
import './DashboardBox.scss';
import api from '../../../config/configApi';
import { MdMoreVert, MdOutlineUpdate } from 'react-icons/md';
import { Alert, Button } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import CircularProgress from '@mui/material/CircularProgress';

const PERIOD_OPTIONS = [
    { label: 'Último Dia', value: 1 },
    { label: 'Última Semana', value: 2 },
    { label: 'Útimo Mês', value: 3 },
    { label: 'Último Ano', value: 4 },
];
const ITEM_HEIGHT = 48;

function DashboardBox({ color, icon, title, apiPath, initialOption = 1, disabledBtn, renderValue }) {
    const [selectedOption, setSelectedOption] = useState(initialOption);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // ESTADOS E HANDLERS PARA O MENU
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    
    const handleMenuItemClick = (optionValue) => {
        setSelectedOption(optionValue); // Atualiza a opção selecionada
        handleClose(); // Fecha o menu APÓS a seleção
    };

    const fetchData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            // Monta a URL da API com a opção selecionada
            // Ex: /total-visualizacoes/1 ou /anuncios-ativos/2
            const url = disabledBtn ? apiPath : `${apiPath}/${selectedOption}`;
            const response = await api.get(url);
            setData(response.data); // Supondo que a resposta seja { total_visualizacoes: N }
        } catch (err) {
            const errMessage = err.response?.data?.msg || err.message || 'Erro descohecido ao carregar dados';
            setError(`Erro ao carregar dados: ${errMessage}`);
            setData(null); // Limpa dados em caso de erro
        } finally {
            setLoading(false);
        }
    }, [apiPath, disabledBtn, selectedOption]);

    useEffect(() => {
        fetchData(selectedOption);
    }, [fetchData, selectedOption]);    

    return (
        <>
            {loading && !error && (
                <div className='dashboardBox align-items-center' style={{
                    backgroundImage: `linear-gradient(to right, ${color?.[0]}, ${color?.[1]})`,
                }}>
                    <div className='d-flex justify-content-center align-items-center h-100 loadingBox'>
                        <CircularProgress sx={{ color: 'white' }} />
                    </div>
                </div>
            )}
            {!loading && error && (
                <div className='dashboardBox align-items-center' style={{
                    backgroundImage: `linear-gradient(to right, ${color?.[0]}, ${color?.[1]})`,
                }}>
                    <Alert severity='error'>{error}</Alert>
                </div>
            )}
            {!loading && !error && data && (
                <div className='dashboardBox' style={{
                    backgroundImage: `linear-gradient(to right, ${color?.[0]}, ${color?.[1]})`,
                }}>
                    <span className='chart'>
                        {icon}
                    </span>

                    <div className='d-flex w-100'>
                        <div className='col1'>
                            <h4 className='text-white mb-0'>{title}</h4>
                            {data ? (renderValue ? renderValue(data) : 'N/A') : 'N/A'}
                        </div>

                        <div className='ms-auto'>
                            {icon ?
                                <span className='icon'>
                                    {icon ? icon : ''}
                                </span>
                                :
                                ''
                            }
                        </div>
                    </div>

                    {!disabledBtn &&
                        <div className='d-flex align-items-center w-100 bottomEle'>

                            {selectedOption === 1 &&
                                <h6 className='text-white mb-0 mt-0'>{PERIOD_OPTIONS[0].label}</h6>
                            }
                            {selectedOption === 2 &&
                                <h6 className='text-white mb-0 mt-0'>{PERIOD_OPTIONS[1].label}</h6>
                            }
                            {selectedOption === 3 &&
                                <h6 className='text-white mb-0 mt-0'>{PERIOD_OPTIONS[2].label}</h6>
                            }
                            {selectedOption === 4 &&
                                <h6 className='text-white mb-0 mt-0'>{PERIOD_OPTIONS[3].label}</h6>
                            }

                            <div className='ms-auto'>
                                <Button
                                    className='toggleIcon'
                                    onClick={handleClick}
                                >
                                    <MdMoreVert />
                                </Button>
                                <Menu
                                    MenuListProps={{
                                        'aria-labelledby': 'long-button',
                                    }}
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    slotProps={{
                                        paper: {
                                            style: {
                                                maxHeight: ITEM_HEIGHT * 4.5,
                                                width: '20ch',
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem onClick={() => handleMenuItemClick(1)}>
                                        <MdOutlineUpdate style={{ marginRight: '10px' }} /> Último Dia
                                    </MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClick(2)}>
                                        <MdOutlineUpdate style={{ marginRight: '10px' }} /> Última Semana
                                    </MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClick(3)}>
                                        <MdOutlineUpdate style={{ marginRight: '10px' }} /> Último Mês
                                    </MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClick(4)}>
                                        <MdOutlineUpdate style={{ marginRight: '10px' }} /> Último Ano
                                    </MenuItem>
                                </Menu>
                            </div>
                        </div>
                    }
                </div>
            )}
        </>
    )
}

export default DashboardBox;
